module.exports = "https://static.wmbcdn.com/uniweb/images/bd94734f372ee5064e063e8271f52a0b.svg";